// Real owner case studies with hard numbers — same content across locales
// (metrics and pull-quotes are factual). Only the UI labels are translated.
export const CASE_STUDIES = [
  {
    id: "carre-dor-studio",
    name: "Carré d'Or Design Studio",
    location: "Nice · Carré d'Or",
    type: "Studio Apartment",
    since: "October 2023",
    ownerFlag: "🇺🇸",
    ownerCountry: "United States",
    challenge:
      "Inconsistent occupancy, outdated marketing, and the owner was considering long-term rental due to disappointing returns.",
    actions: [
      "Completely redesigned the listing with professional photography and compelling copy.",
      "Implemented dynamic pricing and revenue management across Airbnb and Booking.com.",
      "Introduced premium guest communication and hotel-quality operational standards.",
    ],
    metrics: [
      { label: "Occupancy", from: "58%", to: "91%" },
      { label: "Avg. Nightly Rate", change: "+23%" },
      { label: "Annual Revenue", change: "+47%" },
      { label: "Guest Rating", to: "4.96/5" },
      { label: "Payback", to: "4 months" },
    ],
    quote:
      "Velmira completely transformed the performance of my apartment. The professionalism and attention to detail exceeded my expectations.",
  },
  {
    id: "musiciens-family",
    name: "Musiciens Family Apartment",
    location: "Nice · Quartier des Musiciens",
    type: "Two-Bedroom Apartment",
    since: "November 2023",
    ownerFlag: "🇫🇷",
    ownerCountry: "France",
    challenge:
      "Frequent vacancies, poor pricing strategy, and inconsistent guest reviews under the previous management company.",
    actions: [
      "Repositioned the property for families and longer leisure stays.",
      "Coordinated cosmetic improvements and professional staging.",
      "Optimised pricing daily based on demand, seasonality and local events.",
    ],
    metrics: [
      { label: "Occupancy", from: "63%", to: "89%" },
      { label: "Avg. Nightly Rate", change: "+18%" },
      { label: "Annual Revenue", change: "+39%" },
      { label: "Guest Rating", to: "4.95/5" },
      { label: "Superhost", to: "6 months" },
    ],
    quote:
      "Communication is exceptional and I finally feel my property is being managed like a premium hospitality business.",
  },
  {
    id: "cannes-seaview-villa",
    name: "Cannes Seaview Villa",
    location: "Cannes",
    type: "Villa",
    since: "December 2024",
    ownerFlag: "🇺🇸",
    ownerCountry: "United States",
    challenge:
      "Despite an excellent location, the villa lacked premium positioning, resulting in below-market pricing and missed high-season opportunities.",
    actions: [
      "Created a luxury brand identity with new photography and listing optimisation.",
      "Developed a high-end pricing strategy targeting international travellers.",
      "Coordinated maintenance, concierge services and five-star guest experience standards.",
    ],
    metrics: [
      { label: "Occupancy", from: "54%", to: "84%" },
      { label: "Avg. Nightly Rate", change: "+31%" },
      { label: "Annual Revenue", change: "+56%" },
      { label: "Guest Rating", to: "4.98/5" },
      { label: "Payback", to: "5 months" },
    ],
    quote:
      "Velmira delivers the level of service you would expect from a luxury hotel operator. Every detail is handled professionally.",
  },
];
